export const computeSpaceDimensions = (
  windowHeight: number,
  windowWidth: number,
  aspectRatio: number,
) => {
  if (aspectRatio !== 1) {
    // 1. Divide window width by aspect ratio to get potential height
    const heightOfSpaceWhenWidth100Percent = windowWidth / aspectRatio;
    // 2. If compute height is less than the window height start equation to get stretched width
    if (heightOfSpaceWhenWidth100Percent < windowHeight) {
      // 3. Use cross multiplication to calculate width that will fill the space and height that will fill it as well
      const newWidth = (windowWidth * windowHeight) / heightOfSpaceWhenWidth100Percent;
      return { width: newWidth, height: windowHeight };
    }
    // 4. Else return height true to aspect ratio
    return { width: windowWidth, height: heightOfSpaceWhenWidth100Percent };
  }
  // if item is a square, make height and width the same, pick larger value
  const dimension = Math.max(windowWidth, windowHeight);
  return { width: dimension, height: dimension };
};
